import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

import classNames from 'classnames';

import { ProDomain } from 'PMT/entities/security';


export default class ProDomainRow extends Component {

  static propTypes = {
    proDomain: PropTypes.objectOf(ProDomain).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onClick: PropTypes.func.isRequired
  };

  onClick = () => {
    this.props.onClick(this.props.proDomain);
  };

  //
  // Renderers
  //

  render() {
    const className = classNames('choose_pro_domain_view__row', {
      current: this.props.isSelected
    });

    return (
      <div
        className={className}
        onClick={this.onClick}
      >
        {this.props.proDomain.role.name} @ {this.props.proDomain.restaurantsGroup.name}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/header/components/ProDomainRow.js